export enum SystemRole {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export enum GroupRole {
  GROUP_ADMIN = 'GROUP_ADMIN',
  GROUP_SENDER = 'GROUP_SENDER',
  GROUP_MEMBER = 'GROUP_MEMBER',
}

export enum Permission {
  ACCESS_ADMINISTRATION = 'ACCESS_ADMINISTRATION',

  VIEW_REMINDER_LIST = 'VIEW_REMINDER_LIST',
  VIEW_REMINDER_DETAILS = 'VIEW_REMINDER_DETAILS',
  CREATE_REMINDER = 'CREATE_REMINDER',
  EDIT_REMINDER = 'EDIT_REMINDER',
  DELETE_REMINDER = 'DELETE_REMINDER',
  ACTIVATE_REMINDER = 'ACTIVATE_REMINDER',
  DEACTIVATE_REMINDER = 'DEACTIVATE_REMINDER',

  VIEW_GROUP_LIST = 'VIEW_GROUP_LIST',
  SEARCH_GROUPS = 'SEARCH_GROUPS',
  VIEW_ARCHIVED_GROUPS = 'VIEW_ARCHIVED_GROUPS',
  OPEN_GROUP_DETAILS = 'OPEN_GROUP_DETAILS',

  CREATE_GROUP = 'CREATE_GROUP',
  EDIT_GROUP = 'EDIT_GROUP',
  EDIT_GROUP_LIMITED = 'EDIT_GROUP_LIMITED',
  ARCHIVE_GROUP = 'ARCHIVE_GROUP',
  DELETE_GROUP = 'DELETE_GROUP',

  VIEW_GROUP_USERS = 'VIEW_GROUP_USERS',

  ADD_GROUP_MEMBER = 'ADD_GROUP_MEMBER',
  REMOVE_GROUP_MEMBER = 'REMOVE_GROUP_MEMBER',

  ADD_GROUP_SENDER = 'ADD_GROUP_SENDER',
  REMOVE_GROUP_SENDER = 'REMOVE_GROUP_SENDER',

  ADD_GROUP_ADMIN = 'ADD_GROUP_ADMIN',
  REMOVE_GROUP_ADMIN = 'REMOVE_GROUP_ADMIN',

  VIEW_PENDING_REQUESTS = 'VIEW_PENDING_REQUESTS',
  APPROVE_REQUEST = 'APPROVE_REQUEST',
  DECLINE_REQUEST = 'DECLINE_REQUEST',

  VIEW_MESSAGES = 'VIEW_MESSAGES',
  SEND_MESSAGE = 'SEND_MESSAGE',
  EDIT_MESSAGE = 'EDIT_MESSAGE',
  DELETE_MESSAGE = 'DELETE_MESSAGE',
  SEARCH_MESSAGES = 'SEARCH_MESSAGES',
  ATTACH_FILES = 'ATTACH_FILES',

  VIEW_TAG_CATALOG = 'VIEW_TAG_CATALOG',
  CREATE_TAG = 'CREATE_TAG',
  EDIT_TAG = 'EDIT_TAG',
  DELETE_TAG = 'DELETE_TAG',
  ASSIGN_TAGS = 'ASSIGN_TAGS',
  VIEW_GROUP_TAGS = 'VIEW_GROUP_TAGS',
  FILTER_SEARCH_BY_TAGS = 'FILTER_SEARCH_BY_TAGS',

  VIEW_TELEGRAM_NAME = 'VIEW_TELEGRAM_NAME',
  EDIT_TELEGRAM_NAME = 'EDIT_TELEGRAM_NAME',
  SEARCH_TELEGRAM_NAME = 'SEARCH_TELEGRAM_NAME',

  INITIALIZE_SYSTEM_TELEGRAM = 'INITIALIZE_SYSTEM_TELEGRAM',
  CHANGE_SYSTEM_TELEGRAM = 'CHANGE_SYSTEM_TELEGRAM',
  REAUTHORIZE_SYSTEM_TELEGRAM = 'REAUTHORIZE_SYSTEM_TELEGRAM',

  CONFIGURE_GROUP_SORTING = 'CONFIGURE_GROUP_SORTING',
}

// interface PermissionDto {
//   [key: string]: boolean;
// }

export type PermissionMap = Partial<Record<Permission, boolean>>;

// export type CurrentUserPermissionsDto = {
//   permissions: PermissionMap;
// };

export type CurrentUserPermissionsDto = {
  systemRole?: SystemRole | null;
  permissions: PermissionMap;
};

export type GroupPermissionsDto = {
  permissions: PermissionMap;
};

export type GroupPermissionsResponseDto = PermissionMap;
